(function(angular, module) {var stickyHeaderDirective;

stickyHeaderDirective = function(Page) {
  'ngInject';
  return {
    restrict: 'C',
    link: function(scope, element, attrs) {
      var refresh, scrollContainer;
      scrollContainer = Page.element();
      refresh = function() {
        var rect;
        element.removeClass('sticky');
        rect = element[0].getBoundingClientRect();
        element.toggleClass('sticky', rect.top <= 0);
      };
      scrollContainer.on('scroll', refresh);
      scope.$on('resize', refresh);
      scope.$on('$destroy', function() {
        return scrollContainer.off('scroll', refresh);
      });
      return refresh();
    }
  };
};

module.directive('stickyHeader', stickyHeaderDirective);
})(angular, angular.module("dyb.util"));